import ButtonTableAction from '../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../components/default/DefaultDataTable';

interface Exchange {
    id: number;
    currency: string;
    name?: string;
    value: number;
    exchange_date: string;
}

interface ExchangeFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

interface Props {
    exchanges: Exchange[];
    totalRows: number;
    loading?: boolean;
    edit?: (exchange: Exchange) => void;
    destroy?: () => void;
    filter: ExchangeFilters;
    setFilter: (filter: ExchangeFilters) => void;
}

const ForeignExchangeDataTable = ({
    exchanges,
    totalRows,
    loading = false,
    edit,
    destroy,
    filter,
    setFilter
}: Props) => {
    const formatPrice = (price: number) => {
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0
        }).format(price);
    };

    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleDateString('es-CL');
    };

    const columns = [
        {
            name: 'Moneda',
            selector: (row: Exchange) => row.currency,
            sortable: true,
            sortField: 'currency',
            cell: (row: Exchange) => (
                <span className="badge bg-primary">
                    {row.currency || row.name || 'N/A'}
                </span>
            )
        },
        {
            name: 'Valor',
            selector: (row: Exchange) => row.value,
            sortable: true,
            sortField: 'value',
            cell: (row: Exchange) => (
                <span className="fw-bold">{formatPrice(row.value)}</span>
            )
        },
        {
            name: 'Fecha',
            selector: (row: Exchange) => row.exchange_date,
            sortable: true,
            sortField: 'exchange_date',
            cell: (row: Exchange) => (
                <span>{row.exchange_date ? formatDate(row.exchange_date) : '-'}</span>
            )
        },
        {
            name: 'Acciones',
            selector: (row: Exchange) => row.id,
            sortable: false,
            cell: (row: Exchange) => (
                <div className="d-flex align-items-center">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row)}
                            title="Editar"
                            classIcon="fa-edit"
                            colorIcon="text-warning"
                            sizeIcon="16"
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy()}
                            title="Eliminar"
                            classIcon="fa-trash"
                            colorIcon="text-danger"
                            sizeIcon="16"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={exchanges}
            progressPending={loading}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default ForeignExchangeDataTable;

